<template>
  <ButtonSquareHoverChecklist
    :title="$t('general__data__buildings')"
    :imgSource="require('@/assets/icons-general/icon-buildings.svg')"
    size="large"
    :hoverButtons="formattedMapLayers"
    :activeState="active ? 'active' : 'inactive'"
    @clicked="toggleVisible"
    @hovered="$emit('MapFilterButtonHovered')"
    @onChecklistToggle="updateFilteredLayers"
  />
</template>

<script>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_FILTERED_MAP_LAYERS } from '@/store/mutation-types'
import { GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE } from '@/store/action-types'

export default {
  name: 'MapFilterButton',
  components: {
    ButtonSquareHoverChecklist
  },
  emits: ['MapFilterButtonHovered'],
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapState({
      clickedItemType: (state) => state.clickedItemType
    }),
    ...mapState(MAPVIEW_PREFIX, {
      filteredMapLayers: (state) => state.filteredLayers
    }),
    ...mapGetters(MAPVIEW_PREFIX, {
      selectedRealEstateId: 'selectedRealEstateId'
    }),
    formattedMapLayers() {
      const formattedLayers = []
      this.filteredMapLayers.forEach((layer) => {
        if (layer.id === 'building' || layer.id === 'realestates') {
          if (layer.title.startsWith('general__data__filter')) layer.title = this.$t(layer.title)
          formattedLayers.push(layer)
        }
      })
      return formattedLayers
    }
  },
  methods: {
    hideHoverButtons() {
      this.active = false
    },
    toggleVisible() {
      this.active = !this.active
    },
    updateFilteredLayers(id) {
      const filteredLayers = this.filteredMapLayers
      const index = filteredLayers.findIndex((layer) => layer.id === id)
      if (index === -1) return
      filteredLayers[index].visible = !filteredLayers[index].visible
      this.setFilteredMapLayers({ filteredLayers })
    },
    ...mapActions(MAPVIEW_PREFIX, {
      getOutdoorZoneDataForRealEstate: GET_OUTDOOR_ZONE_DATA_FOR_REAL_ESTATE
    }),
    ...mapMutations(MAPVIEW_PREFIX, {
      setFilteredMapLayers: SET_FILTERED_MAP_LAYERS
    })
  }
}
</script>

<style lang="scss" scoped></style>
